/* eslint-disable */
import { useState } from "react";
import { Box, styled, Card, useTheme, Typography } from "@mui/material";
import IntroUpArrow from "../../components/SvgIcons/IntroUpArrow";

const BoxWrapper = styled(Box)(({ theme }) => ({
  "& .MainHeading": {
    color: theme.palette.text.primary,
    fontSize: "16px",
    fontWeight: 500,
    lineHeight: "28px",
    position: "relative",
    "& span": {
      color: theme.palette.primary.main,
      fontSize: "16px",
      fontWeight: 700,
      lineHeight: "1",
    },
    "& .IntroUpArrow": {
      position: "absolute",
      left: "-40px",
      top: "-12px",
      width: "65px",
      height: "50px",
      "@media screen and (max-width:1025px)": {
        display: "none",
      },
    },
  },
}));
function GetStartHead() {
  const theme = useTheme();
  return (
    <BoxWrapper>
      <Card
        sx={{
          padding: { xs: "20px 20px 20px 20px", sm: "40px 24px 40px 24px" },
          border: `1px solid ${theme.palette.divider}`,
          boxShadow: "none !important",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography className="MainHeading" component="h2">
          <Typography component="span">Get started:</Typography> Enter in a keyword and click "Search" to find all the related search terms that people are searching for on Google.
          <IntroUpArrow />
        </Typography>
      </Card>
    </BoxWrapper>
  );
}

export default GetStartHead;
